'use strict';

/**
 * Checks if the user has explicitly accepted 'Google Maps' in the 
 * Usercentrics Consent Management Platform.
 * @returns {Promise<boolean>}
 */
async function hasGoogleMapsConsent() {

    const UC = window.UC_UI;

    if (!UC || typeof UC.getServicesBaseInfo !== 'function') {
        return false;
    }

    try {
        const services = await UC.getServicesBaseInfo();
        if (!Array.isArray(services)) return false;

        const googleMaps = services.find(s => s.name === 'Google Maps');
        const hasConsent = googleMaps?.consent?.status === true;

        return hasConsent;
    } catch (e) {
        return false;
    }
}

/**
 * Main logic to handle redirects and UI modifications based on consent and URL
 */
function initializeRetailtune() {
    hasGoogleMapsConsent().then(consent => {
        
        // REGEX: Matches '.../filialen' or '.../filialen/' at the end of the URL \/?$ ensures it handles the optional trailing slash
        const isStorePage = /\/filialen\/?$/.test(window.location.href);

        // Redirect to /all-stores if the main map page is blocked by lack of consent
        if (!consent && isStorePage &&!window.location.pathname.includes("/filialen/all-stores")) {
            window.location.replace("/filialen/all-stores");
            return;
        } 

        // If on the fallback page, hide elements that rely on Google Maps (like directions)
        if (window.location.pathname.includes("/filialen/all-stores")) {
            const storeLocatorCTAs = document.querySelectorAll('.rt-store-card__directions');
            storeLocatorCTAs.forEach(cta => {
                cta.setAttribute('aria-hidden', 'true');
                cta.style.display = 'none';
            });
        }
    });
}

/**
 * Ensures the script only runs once the Usercentrics API is fully ready.
 */
if (window.UC_UI && window.UC_UI.isInitialized()) {
   initializeRetailtune();
} else {
   window.addEventListener('UC_UI_INITIALIZED', initializeRetailtune);
}